module.exports = __webpack_public_path__ + "static/media/payments_inactive.35338eca.svg";